import * as types from '../const/action.types';
import { get, post, put } from '../api/_basic';

export function loadXef(local) {
    return async (dispatch) => {
        dispatch(xefHasErrored(false, ''));
        dispatch(xefIsLoading(true));
        dispatch(productionIsSaving(false));
        return get(`${process.env.REACT_APP_API_LOCAL}/${local}/produccion`)
            .then((response) => {
                dispatch(xefIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(xefHasErrored(false, ''));
                dispatch(loadXefSuccess(items));
            })
            .catch((error) => {
                dispatch(xefIsLoading(false));
                dispatch(xefHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addProduction(production) {
    return async (dispatch) => {
        dispatch(productionIsSaving(true));
        return post(
            `${process.env.REACT_APP_API_LOCAL}/${production.idLocal}/produccion`,
            production,
        )
            .then((response) => {
                dispatch(productionIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                console.log(response);
                //dispatch(addEvent([{ evento: 'PRD_ALTA', payload: response }]));
                return true;
            })
            .catch((error) => {
                dispatch(productionIsSaving(false));
                console.log(error);
                throw error;
            });
    };
}

export function production(production) {
    return async (dispatch) => {
        dispatch(productionIsSaving(true));
        return put(
            `${process.env.REACT_APP_API_LOCAL}/${production.idLocal}/produccion/${production.idProduccion}/producir`,
            production,
        )
            .then((response) => {
                dispatch(productionIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                //dispatch(addEvent([{ evento: 'PRD_PROD', payload: response.data }]));
                return true;
            })
            .catch((error) => {
                dispatch(productionIsSaving(false));
                console.log(error);
                throw error;
            });
    };
}

export function removeproduction(production) {
    return async (dispatch) => {
        dispatch(productionIsSaving(true));
        return put(
            `${process.env.REACT_APP_API_LOCAL}/${production.idLocal}/produccion/${production.idProduccion}/detener`,
            production,
        )
            .then((response) => {
                dispatch(productionIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                dispatch(productionIsSaving(false));
                console.log(error);
                throw error;
            });
    };
}

export function decrease(production) {
    return async (dispatch) => {
        return put(
            `${process.env.REACT_APP_API_LOCAL}/${production.idLocal}/produccion/${production.idProduccion}/mermar`,
            production,
        )
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function addEvent(events) {
    return {
        type: types.XEF_ADD_EVENTS,
        events,
    };
}

export function xefTimeReference(time) {
    return {
        type: types.XEF_TIME_REFERENCE,
        time,
    };
}

export function loadXefSuccess(data) {
    return {
        type: types.XEF_SUCCESS,
        data,
    };
}

export function xefHasErrored(bool, message) {
    return {
        type: types.XEF_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function xefIsLoading(bool) {
    return {
        type: types.XEF_IS_LOADING,
        isLoading: bool,
    };
}

export function productionIsSaving(bool) {
    return {
        type: types.XEF_IS_SAVING,
        isSaving: bool,
    };
}

export function setXefLocal(id) {
    return {
        type: types.XEF_SET_LOCAL,
        local: id,
    };
}



// WEBPACK FOOTER //
// ./src/actions/xhef.actions.js